import { ContentLimiter } from 'components/atoms';
import { ContentRow } from 'components/molecules';
import { KSV, PurchasableDocument } from 'components/profiles';
import React from 'react';
import { ISO8601Date } from 'types';
import { UnternehmenDto } from 'types/unternehmen';
import { useTranslation } from 'utils/hooks';

type DocumentType = 'Jahresabschluss' | 'Aktueller Firmenbuchauszug' | 'Historischer Firmenbuchauszug';

interface DokumenteProps 
{
  unternehmen: UnternehmenDto;
}

const Dokumente: React.FC<DokumenteProps> = (props) =>
{
  const { unternehmen } = props;
  const { t } = useTranslation('profiles');

  const now = new Date().toISOString().substring(0, 10);

  function getAuszugAtDocumentLink(documentType: DocumentType, date: ISO8601Date)
  {
    const params = new URLSearchParams({
      companyName: unternehmen.name,
      fbNr: unternehmen.fbNr,
      type: documentType,
      date,
    });

    return `https://www.auszug.at/direktkauf/produkte?${params.toString()}`;
  }

  return (
    <>
      {/* Bonität & Dokumente */}
      <ContentRow id="dokumente" title={t('profiles:unternehmen.documents.label')}>

        <KSV name={unternehmen.name} />

        <hr style={{ marginBlock: '1rem' }} />

        <ul className="no-list-style">
          <ContentLimiter initialLimit={3} stepSize={5}>
            {[
              <PurchasableDocument
                key="fbAuszugAktuell"
                text={t('profiles:unternehmen.documents.fbAuszugAktuell')}
                href={getAuszugAtDocumentLink('Aktueller Firmenbuchauszug', now)}
              />,

              <PurchasableDocument
                key="fbAuszugHistorisch"
                text={t('profiles:unternehmen.documents.fbAuszugHistorisch')}
                href={getAuszugAtDocumentLink('Historischer Firmenbuchauszug', now)}
              />,

              ...unternehmen.jahresabschlüsse.sort((a, b) => b.dueDate.localeCompare(a.dueDate)).map((jahresabschluss) => (
                <PurchasableDocument
                  key={jahresabschluss.dueDate + jahresabschluss.submissionDate}
                  text={t('profiles:unternehmen.documents.jahresabschluss', { dueDate: jahresabschluss.dueDate, submissionDate: jahresabschluss.submissionDate })}
                  href={getAuszugAtDocumentLink('Jahresabschluss', jahresabschluss.dueDate)}
                />
              )),
            ]}
          </ContentLimiter>
        </ul>
      </ContentRow>

    </>
  );
};

export default Dokumente;
